import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../components/Common/Card';
import Input from '../../components/Common/Input';
import Button from '../../components/Common/Button';
import api from '../../utils/api';
import { ArrowLeft } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { usePermission } from '../../hooks/usePermission';

const DepartmentForm = () => {
  const { user } = useAuth();
  const { canCreate, canEdit } = usePermission();
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
  });
  const isEditMode = !!id;

  useEffect(() => {
    if (isEditMode ? !canEdit('departments') : !canCreate('departments')) {
      navigate('/');
      return;
    }

    if (isEditMode) {
      fetchDepartment();
    }
  }, [id]);

  const fetchDepartment = async () => {
    try {
      const response = await api.get(`/departments/${id}`);
      setFormData({
        name: response.data.name,
      });
    } catch (error) {
      console.error('Departman yüklenemedi:', error);
      alert('Departman yüklenemedi');
      navigate('/departments');
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (isEditMode) {
        await api.put(`/departments/${id}`, formData);
      } else {
        await api.post('/departments', formData);
      }
      navigate('/departments');
    } catch (error) {
      console.error('Departman kaydedilirken hata:', error);
      alert('Departman kaydedilirken bir hata oluştu');
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="mb-6">
        <Button variant="secondary" size="sm" onClick={() => navigate('/departments')}>
          <ArrowLeft size={16} />
          Geri
        </Button>
      </div>

      <Card title={isEditMode ? "Departman Düzenle" : "Yeni Departman Ekle"}>
        <form onSubmit={handleSubmit}>
          <Input
            label="Departman Adı"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Örn: Satış Departmanı"
            required
          />

          <div className="flex gap-3 justify-end mt-6">
            <Button
              type="button"
              variant="secondary"
              onClick={() => navigate('/departments')}
            >
              İptal
            </Button>
            <Button type="submit" disabled={loading}>
              {loading ? 'Kaydediliyor...' : isEditMode ? 'Güncelle' : 'Kaydet'}
            </Button>
          </div>
        </form>
      </Card>
    </div>
  );
};

export default DepartmentForm;
